export const HTML_DESCRIPTION_MAX_LENGTH = 2000

export const getHTMLPlainTextLength = (value) => {
  if (!value || value === '<p><br></p>') {
    return 0
  }

  // Replace block tags' closing tags with a newline to count Enters as 1 char
  let plainText = value.replace(/<\/(p|div|h[1-6]|li)>/gi, '\n')

  // Remove all remaining HTML tags
  plainText = plainText.replace(/<[^>]*>/g, '')

  // Decode common HTML entities
  plainText = plainText
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")

  // Remove the trailing newline added by the very last closing block tag
  if (plainText.endsWith('\n')) {
    plainText = plainText.slice(0, -1)
  }

  return plainText.length || 0
}
